import Vue from 'vue'
import Vuex from 'vuex'
import {addSign, getScore, updateObj} from '@/libs/tools'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    subjectList: [],
    allScore: 0,
    resultList: {},    //存下答题后的结果
  },
  getters: {
    getAllsubjectList(state) {
      return state.subjectList
    },
    getAllScore(state) {
      return state.allScore
    },
    getResultList(state) {
      return state.resultList
    }
  },
  mutations: {
    addSubScore(state, subjectArr) {
      state.subjectList = addSign(subjectArr)
    },
    updateSubject(state, newS) {
      //whichSub 哪一题，clicked true, result 根据结果
      let whichsub = newS.whichSub;
      let obj = {
        clicked: newS.clicked,
        result: newS.result
      }
      // console.log(obj, whichsub)
      state.subjectList = updateObj(state.subjectList, whichsub, obj);
      state.allScore = getScore(state.subjectList);
      // 存下答题后的结果
      state.resultList[whichsub] = newS.result
    },
    updateList(state, result) {
      state.subjectList.map((item, index) => {
        if(!item.clicked) {
          item.list = []
        }
        if(index == result.num) {
          item.list.push(result.value)
        }
      })
    },
    clearSubject(state, result) {
      state.subjectList.map((item, index) => {
        if(index == result) {
          item.list = []
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js